/* FlowerAdvisor FAQ accordion: accessible and idempotent. */
(() => {
  const prepare = (root = document) => {
    root.querySelectorAll('.fa-accordion__trigger').forEach((button) => {
      if (button.dataset.faAccordionReady === 'true') return;
      button.dataset.faAccordionReady = 'true';
      button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') || 'false');

      const panelId = button.getAttribute('aria-controls');
      const panel = panelId
        ? document.getElementById(panelId)
        : button.closest('.fa-accordion__item')?.querySelector('.fa-accordion__panel');

      if (panel) panel.hidden = button.getAttribute('aria-expanded') !== 'true';
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.fa-accordion__trigger');
    if (!button) return;

    const panelId = button.getAttribute('aria-controls');
    const panel = panelId
      ? document.getElementById(panelId)
      : button.closest('.fa-accordion__item')?.querySelector('.fa-accordion__panel');

    const willExpand = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(willExpand));
    if (panel) panel.hidden = !willExpand;
  });

  document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
